import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleInventory.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleInventory' */ './component')],
	render: ([AdminBicycleInventory]) => <AdminBicycleInventory />,
};

export default routes;
